import TripStopsEditorContainer from './TripStopsEditorContainer';

export default TripStopsEditorContainer;
